<div class="container">
     <form [formGroup]="formImpedimentoCadin" class="form">
        <div class="row">
            <div class="col">
                <h3>Parametrização Consulta Impedimento</h3>
            </div>
            <div class="col-auto">
                <button class="btn btn-primary no-margin" type="button"
                (click)="salvarEditar()" [disabled]="formImpedimentoCadin.invalid">
                    <i class="fa fa-file-signature"></i> Salvar
                </button>
            </div>
        </div>

      <li class="list-unstyled" title="Quantidade">
        <div class="row">
            <div class="bn-form-group col-md-3">
                <label class="form-label">
                    <b>Qtd. Máxima de Consultas Diárias</b>
                    <i class="fa fa-question-circle help-subtitulo" placement="bottom" ngbTooltip="Quantidade Máxima de Consultas Diárias"></i>
                </label>
                <input class="form-control" name="quantidadeMaximaDiaria" ngDefaultControl formControlName="quantidadeMaximaDiaria">
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label">
                    <b>Qtd. Máxima de Consultas Mensais</b>
                        <i class="fa fa-question-circle help-subtitulo" placement="bottom" ngbTooltip="Quantidade Máxima de Consultas Mensais"></i>
                </label>
                    <input class="form-control" name="quantidadeMaximaMensal" ngDefaultControl formControlName="quantidadeMaximaMensal">
            </div>
        </div>
        </li>
     </form>
</div>
<bn-loading-overlay></bn-loading-overlay>
